let origin = "https://future.zhuneng.cn";
//雅曼互动
const postInteractionUrl = `/gateway/hc-serve/miniapi/wechatInteractiveRecord/add`;
//雅曼互动
const myInteractionUrl = `/gateway/hc-serve/miniapi/wechatInteractiveRecord/mineList`;

export { postInteractionUrl, myInteractionUrl };
